"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const local_mock_component_1 = require("./local-mock.component");
exports.default = process.env.NODE_ENV === 'development' ? local_mock_component_1.LocalMock : null;
//# sourceMappingURL=local-mock-dev.component.js.map